@if (errorMessage !== null || warningMessage !== null) {
  <div>
    @if (errorMessage !== null) {
      <kendo-formerror class="error-message">
        {{ errorMessage | abpLocalization }}
      </kendo-formerror>
    }
    @if (warningMessage !== null) {
      <kendo-formerror class="warning-message">
        {{ warningMessage | abpLocalization }}
      </kendo-formerror>
    }
  </div>
}
